import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import * as React from 'react';
import UsuVistasView from '../../usu_vistas/UsuVistasView';
import FormUsuPerfilComponent from './FormUsuPerfil';
import FormUsuarioComponent from './FormUsuario';

const TabsInfoUsuariosComponent = ({ isUsuarios = true }) => {
  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleTabs} aria-label="lab API tabs example">
          <Tab label="Perfil" value="1" />
          <Tab label="Usuario" value="2" />
          <Tab label="Vistas" value="3" />
        </TabList>
      </Box>
      <TabPanel value="1">
        <FormUsuPerfilComponent />
      </TabPanel>
      <TabPanel value="2">
        <FormUsuarioComponent isUsuarios={isUsuarios} />
      </TabPanel>
      <TabPanel value="3" sx={{ p: 0, pt: 1 }}>
        <UsuVistasView />
      </TabPanel>
    </TabContext>
  );
};

export default TabsInfoUsuariosComponent;
